import { computedDirectiveTransformer } from './computedDirectiveTransformer';
export { computedDirectiveTransformer } from './computedDirectiveTransformer';
export var defaultSubschemaConfigTransforms = [computedDirectiveTransformer('computed')];
//# sourceMappingURL=index.js.map